<div
    *transloco="let t"
    class="bazis-control"
    [class]="'bazis-control ' + cssClassSizeControl"
>
    <ng-container
        *ngIf="{
            required: required$ | async,
        } as data"
        [ngClass]="{
            'bazis-control--focused': isFocused,
            'bazis-control--dirty': ngControl.control.dirty,
            'bazis-control--empty': emptyValues.indexOf(ngControl.control.value) > -1,
            'bazis-control--invalid': ngControl.control.invalid,
            'bazis-control--disabled': searchControl.disabled,
        }"
    >
        <bazis-label
            [isMajor]="hasTitleMajor"
            [isEmptyLabel]="isEmptyLabel"
            [title]="title || t(titleKey, titleParams)"
            [required]="data.required"
        >
            <bazis-interrogation
                *ngIf="tooltipKey"
                [slot]="tooltipSettings?.targetSide"
                iconSize="compact"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipOffset]="[-8, 4]"
                [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                [icon]="icons.interrogation"
                [type]="interrogationType"
            ></bazis-interrogation>
        </bazis-label>

        <div
            class="bazis-list_control-dd-wrapper"
            [class.bh-events-none]="isDisabled"
            clickOutside
            (clickOutside)="hideList()"
        >
            <bazis-input-default
                [formControl]="searchControl"
                [rightIcon]="rightIcon"
                [noteKey]="noteKey"
                [tooltipKey]="tooltipKey"
                [placeholderKey]="placeholderKey"
                [noteParams]="noteParams"
                [tooltipParams]="tooltipParams"
                [tooltipSettings]="tooltipSettings"
                [hasEraser]="hasEraser"
                [required$]="required$"
                [sizeControl]="sizeControl"
                (touched)="markAsTouched()"
                (focused)="isFocused = true; showList = true"
                (blured)="isFocused = false"
                (click)="toggleList()"
            >
                <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
            </bazis-input-default>

            <bazis-infinite-list
                *ngIf="showList"
                [searchSettings]="searchSettings"
                [emptyListKey]="emptyListKey"
                [search$]="searchControl.valueChanges"
            >
                <ng-template let-item="item">
                    <div
                        class="bazis-item"
                        (click)="
                            selectValue(
                                searchSettings.fieldForId
                                    ? item.$snapshot[searchSettings.fieldForId]
                                    : item.$snapshot.name
                            )
                        "
                    >
                        <ng-container
                            *ngIf="infiniteListTpl"
                            [ngTemplateOutlet]="infiniteListTpl"
                            [ngTemplateOutletContext]="{ item: item }"
                        ></ng-container>
                        <ng-container *ngIf="!infiniteListTpl">
                            {{
                                searchSettings.fieldForId
                                    ? item.$snapshot[searchSettings.fieldForId]
                                    : item.$snapshot.name
                            }}
                        </ng-container>
                    </div>
                </ng-template>
            </bazis-infinite-list>
        </div>
    </ng-container>
</div>

<!-- DO NOT REMOVE -->
<ng-container *ngIf="searchValue$ | async"></ng-container>
